import { Alert, AlertTitle } from "@material-ui/lab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";

import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Tab from "@mui/material/Tab";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { IReduxState } from "../store";
import { IReduxState } from "../store";
import AppAdmin from "./AppAdmin";
import AppGestionInterne from "./AppGestionInterne";
import GestionFonctionnalite from "../components/GestionFonctionnalite";

function GestionUtilisateur() {
  //redux
  const { goToParameter} = useSelector((state: IReduxState) => state.application);
  const dispatch = useDispatch();

  // hooks
  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
            >
              <Tab label="App admin" value="1" />
              <Tab label="Spider web" value="2" />
              <Tab label="App gestion interne" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <AppAdmin />
          </TabPanel>
          <TabPanel value="2">
          <GestionFonctionnalite />
          </TabPanel>
          <TabPanel value="3">
            <AppGestionInterne />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}

export default GestionUtilisateur;
